import dayjs from "dayjs";

export const formatDate = (date: string | Date, format: string = "YYYY-MM-DD HH:mm:ss") => {
  return dayjs(date).format(format);
};
